export enum EngagementType {
  Project = "Project",
  Canopy = "Canopy",
  Survey = "Survey"
}

export enum EngagementStatus {
  Pending = "Pending",
  Active = "Active",
  InProgress = "InProgress",
  PendingApproval = "PendingApproval",
  InReview = "InReview",
  Completed = "Completed",
  Closed = "Closed"
}

export enum EngagementStatusGroup {
  New = "New",
  Ongoing = "Ongoing",
  Completed = "Completed",
  Closed = "Closed"
}

export enum EngagementOrderBy {
  Date = "Date"
}

export enum EngagementStatusColor {
  Pending = "success",
  Active = "processing",
  InProgress = "success",
  PendingApproval = "warning",
  InReview = "processing",
  Completed = "processing",
  Closed = "error"
}

export enum EngagementTypeIcon {
  Project = "phone_in_talk",
  Canopy = "video_camera_front",
  Survey = "assignment"
}

export interface ExpertEngagement {
  productId: string;
  expertProductId: string | null;
  title: string;
  type: EngagementType;
  status: EngagementStatus;
  date: string;
}

export interface GetExpertEngagementsParams {
  offset: number;
  limit: number;
  orderBy: EngagementOrderBy;
  searchTerm?: string;
  productTypes?: EngagementType[];
}

export interface EngagementActionCardSecondaryAction {
  label: string;
  onClick: () => void;
}

export interface EngagementCard {
  key: string;
  title: string;
  subtitle: string;
  badgeLabel: string;
  badgeColor: string;
  engagementType: string;
  date?: string;
  actionLabel: string;
  actionPathname?: string;
  onAction?: () => void;
  secondaryAction?: EngagementActionCardSecondaryAction;
}
